import {
  ADD_BANNER_PLACEMENT_START,
  ADD_BANNER_PLACEMENT_SUCCESS,
  ADD_BANNER_PLACEMENT_ERROR,
  DELETE_BANNER_PLACEMENT_START,
  DELETE_BANNER_PLACEMENT_SUCCESS,
  DELETE_BANNER_PLACEMENT_ERROR,
  GET_BANNER_PLACEMENTS_START,
  GET_BANNER_PLACEMENTS_SUCCESS,
  GET_BANNER_PLACEMENTS_ERROR
} from '../../../constants';

import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';

const ADD_BANNER_PLACEMENT_MUTATION = gql`
mutation($name: String!, $label: String!, $height: Int!, $width: Int!) {
  createBannerPlacement(name: $name, label: $label, height: $height, width: $width) {
    status
    errorMessage
    result { id name label height width }
  }
}`;

const DELETE_BANNER_PLACEMENT_MUTATION = gql`
mutation($id: Int!) {
  deleteBannerPlacement(id: $id) {
    status
    errorMessage
  }
}`;

const GET_BANNER_PLACEMENTS_QUERY = gql`
query bannerPlacements {
  bannerPlacements {
    results {
      id
      name
      label
      height
      width
      createdAt
      updatedAt
    }
    status
    errorMessage
  }
}`;

const EDIT_BANNER_PLACEMENT_MUTATION = gql`
mutation($id: Int!, $name: String!, $label: String!, $height: Int!, $width: Int!) {
  editBannerPlacement(id: $id, name: $name, label: $label, height: $height, width: $width) {
    status
    errorMessage
    result { id name label height width }
  }
}`;

export function addBannerPlacement(values) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: ADD_BANNER_PLACEMENT_START });
    dispatch(setLoaderStart('AddBannerPlacement'));
    try {
      const { data } = await client.mutate({
        mutation: ADD_BANNER_PLACEMENT_MUTATION,
        variables: values
      });
      if (data && data.createBannerPlacement && data.createBannerPlacement.status === 200) {
        toastr.success('Success', 'Banner placement has been added successfully.');
        dispatch({ type: ADD_BANNER_PLACEMENT_SUCCESS });
      } else {
        toastr.error('Error', data.createBannerPlacement.errorMessage || 'Failed to add banner placement.');
        dispatch({ type: ADD_BANNER_PLACEMENT_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: ADD_BANNER_PLACEMENT_ERROR });
    }
    dispatch(setLoaderComplete('AddBannerPlacement'));
  };
}

export function deleteBannerPlacement(id) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: DELETE_BANNER_PLACEMENT_START });
    dispatch(setLoaderStart('DeleteBannerPlacement'));
    try {
      const { data } = await client.mutate({
        mutation: DELETE_BANNER_PLACEMENT_MUTATION,
        variables: { id }
      });
      if (data && data.deleteBannerPlacement && data.deleteBannerPlacement.status === 200) {
        toastr.success('Success', 'Banner placement has been deleted successfully.');
        dispatch({ type: DELETE_BANNER_PLACEMENT_SUCCESS });
      } else {
        toastr.error('Error', data.deleteBannerPlacement.errorMessage || 'Failed to delete banner placement.');
        dispatch({ type: DELETE_BANNER_PLACEMENT_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: DELETE_BANNER_PLACEMENT_ERROR });
    }
    dispatch(setLoaderComplete('DeleteBannerPlacement'));
  };
}

export function getBannerPlacements() {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: GET_BANNER_PLACEMENTS_START });
    try {
      const { data } = await client.query({
        query: GET_BANNER_PLACEMENTS_QUERY,
        fetchPolicy: 'network-only'
      });
      if (data && data.bannerPlacements && data.bannerPlacements.status === 200) {
        dispatch({
          type: GET_BANNER_PLACEMENTS_SUCCESS,
          payload: data.bannerPlacements.results
        });
      } else {
        toastr.error('Error', data.bannerPlacements.errorMessage || 'Failed to fetch banner placements.');
        dispatch({ type: GET_BANNER_PLACEMENTS_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: GET_BANNER_PLACEMENTS_ERROR });
    }
  };
}

export function editBannerPlacement(values) {
  return async (dispatch, getState, { client }) => {
    dispatch(setLoaderStart('EditBannerPlacement'));
    try {
      const { data } = await client.mutate({
        mutation: EDIT_BANNER_PLACEMENT_MUTATION,
        variables: values
      });
      if (data && data.editBannerPlacement && data.editBannerPlacement.status === 200) {
        toastr.success('Success', 'Banner placement has been updated successfully.');
      } else {
        toastr.error('Error', data.editBannerPlacement.errorMessage || 'Failed to update banner placement.');
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
    }
    dispatch(setLoaderComplete('EditBannerPlacement'));
  };
} 